import { ClaudeTemplate } from "../types";

export const xAdsTemplate: ClaudeTemplate = {
  id: "x-ads",
  tool: "X Ads (antes Twitter Ads)",
  url: "https://ads.x.com/",
  hierarchy: "Ad account → Campaign → Ad group → Ads",
  idHint: "ID de la campaña en la URL al abrirla o en el detalle de la campaña",
  steps: `
### 1. Entrar en la cuenta (puede que ya estés dentro)
1. Abre X Ads ({{url}}). Si ya está abierto, sigue.
2. Elige la **Ad account** de {{client}} en el selector de cuentas. Si hay varias, pregunta.

### 2. Campaign
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, crea una nueva (modo avanzado, no el asistente rápido):
   - Objective según {{goal.kpi}}: CPM → Reach; CPC → Website traffic; CPV → Video views; CPE → Engagements; CPA/CPL → Website conversions.
   - Campaign name: {{names.order}}
   - Funding source: la de la cuenta. Si hay varias, pregunta.
   - Presupuesto de campaña: {{goal.budget}} total, del {{goal.startDate}} al {{goal.endDate}}.

### 3. Ad group
1. Ad group name: {{names.line}}
2. Fechas: {{goal.startDate}} → {{goal.endDate}}. Presupuesto: el de la campaña salvo que las notas digan otra cosa.
3. Bid: autobid por defecto; si las notas piden coste controlado, target cost en torno a {{goal.netUnitCost}}.
4. Targeting: ubicación {{target.geography}} (país {{goal.country}}), edad {{target.age}}, sexo {{target.gender}}, idioma {{target.language}}, dispositivos {{target.technology}}, intereses / palabras clave / seguidores parecidos {{target.interests}}, audiencias {{target.audience}}, exclusiones {{target.exclusions}}.
5. Placements: los recomendados para el objetivo, salvo que las notas digan otra cosa.

### 4. Ads
1. Crea un anuncio por pieza del bloque "Creatividades", con el texto del bloque "Copies" y la URL de destino (con UTM). Si el tipo es SOCIAL_POSTS, promociona el post indicado en el briefing; si no se indica, pregunta.
2. Cuenta de X que publica: la de {{brand}} / {{client}}.
3. Guarda la campaña como **borrador**. No la lances sin mi confirmación.
`,
};
